/**
 * Apple Auth Service - Handles Apple authentication
 */
const appleAuthService = {
  /**
   * Initialize Apple Sign In
   * @returns {Promise} Resolves when Apple Sign In is initialized
   */
  initAppleSignIn: () => {
    return new Promise((resolve) => {
      // Check if AppleID script is already loaded
      if (window.AppleID) {
        resolve(window.AppleID);
        return;
      }

      // Load the Apple Sign In script
      const script = document.createElement('script');
      script.src = 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js';
      script.async = true;
      script.onload = () => {
        // Initialize Apple Sign In
        window.AppleID.auth.init({
          clientId: 'indiefy.net', // Replace with your Apple Client ID
          scope: 'name email',
          redirectURI: `${window.location.origin}/auth/callback`,
          state: 'apple-sign-in',
          usePopup: true,
        });
        resolve(window.AppleID);
      };
      document.head.appendChild(script);
    });
  },

  /**
   * Sign in with Apple
   * @returns {Promise} Resolves to Apple user data
   */
  signInWithApple: async () => {
    try {
      // Initialize Apple Sign In if not already initialized
      await appleAuthService.initAppleSignIn();

      // Trigger Apple Sign In
      const data = await window.AppleID.auth.signIn();

      // Extract user data
      const userData = {
        id: data.authorization.id_token,
        email: data.user?.email,
        name: data.user?.name?.firstName + ' ' + data.user?.name?.lastName,
        provider_token: data.authorization.id_token,
      };

      return userData;
    } catch (error) {
      console.error('Error signing in with Apple:', error);
      throw error;
    }
  },

  /**
   * Sign out from Apple
   * @returns {Promise} Resolves when signed out
   */
  signOutFromApple: async () => {
    try {
      if (window.AppleID && window.AppleID.auth) {
        await window.AppleID.auth.signOut();
      }
    } catch (error) {
      console.error('Error signing out from Apple:', error);
      throw error;
    }
  },
};

export default appleAuthService;